import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { format, parseISO } from 'date-fns';
import ActionButtons from './components/ActionButtons';

const sticky = {
  position: 'sticky',
  top: 0,
  backgroundColor: '#fff'
};

function LicensesTable({ rows, triggerRefetch }) {
  return (
    <TableContainer component={Paper} sx={{width: 'auto', boxShadow: 'none', height: '100%'}}>
      <Table sx={{minWidth: 650}}>
        <TableHead>
          <TableRow>
            <TableCell sx={sticky}>Наименование</TableCell>
            <TableCell sx={sticky}>Дата активации</TableCell>
            <TableCell sx={sticky}>Срок действия</TableCell>
            <TableCell sx={sticky}>Статус</TableCell>
            <TableCell sx={sticky}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id} sx={{'&:last-child th': {border: 0}}}>
              <TableCell>{row.company_name ?? '—'}</TableCell>
              <TableCell>{row.activation_date ? format(parseISO(row.activation_date), 'dd.MM.yyyy') : '—'}</TableCell>
              <TableCell>{row.expiration_date ? format(parseISO(row.expiration_date), 'dd.MM.yyyy HH:mm:ss') : '—'}</TableCell>
              <TableCell>{row.is_active ? 'Активна' : 'Неактивна'}</TableCell>
              <TableCell sx={{whiteSpace: 'nowrap'}}>
                <ActionButtons isActive={row.is_active} id={row.id} triggerRefetch={triggerRefetch}/>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default LicensesTable;
